module.exports = __webpack_public_path__ + "static/img/20019 (3).2938348.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20019 (3).webp
// module id = 3leJ
// module chunks = 14